import React, { Component } from "react";
import HistoricElectronicPayrollForm from "../HistoricElectronicPayrollForm/HistoricElectronicPayrollForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : OvertimePage
Description : Componente que contienen el formulario de la pantalla Overtime
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente OvertimeForm
================================================================================ */
class HistoricElectronicPayrollPage extends Component {
    render() {
        return (
            <div>
                <HistoricElectronicPayrollForm />
            </div>
        )
    }
}

export default HistoricElectronicPayrollPage;